export default {
  keywordAlternatives: [],
  keywordAlternative: undefined,
};
